// extracted by mini-css-extract-plugin
export default {"settingsContainer":"Settings_settingsContainer__-+MaH","settings-button":"Settings_settings-button__SaGku"};